import {jsx} from 'panel';

import {ControlBarEl} from 'common/widgets/control-bar';
import {DropMenuEl} from 'common/components/drop-menu';
import {BucketPaneEl} from 'common/widgets/bucket-pane';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {hasNewQBUI} from 'common/widgets/query-builder/util';
import {SelectEl, THEME} from 'common/components/select';

import type {QueryEntrySection} from '../index';
import {Action, EntryPart, QueryMetricEntry, QuerySuperEntry} from '../types';

export function RowActions({el, index, entry}: {el: QueryEntrySection; entry: QuerySuperEntry; index: number}) {
  const hasNewUI = hasNewQBUI();
  const {activeEntry, entryPart} = el.state;
  const isBehavior = el.helpers.hasBehavioralFrequencyFilter(entry as QueryMetricEntry);
  const overflowControls = el.helpers.getEntryOverflowControls(index);
  const showOverflowMenu = overflowControls.length > 0;

  if (hasNewUI) {
    return (
      <div sel='.mp-query-entry-actions'>
        <SelectEl
          key='entry-actions'
          attrs={{
            elref: `lineActions`,
            'menu-width': 200,
            disabled: el.attr(`disabled`),
            theme: THEME.TERTIARY,
            icon: {leftIcon: hasNewUI ? `gripper` : `hor-ellipsis`},
            tooltip: {text: `**Drag** to move\n**Click** to open menu`},
            'icon-only': true,
          }}
          props={{
            sections: overflowControls,
          }}
          on={{
            change: (ev: CustomEvent) => el.helpers.onControlSelect(ev.detail.item.value, index),
            mousedown: () => el.update({draggingGripperIndex: index}),
          }}
        />
      </div>
    );
  }

  return (
    <div sel='.mp-query-entry-actions'>
      {!el.helpers.hasBehavioralFrequencyFilter(entry as QueryMetricEntry) && (
        <div sel='.mp-query-control-bar-container'>
          {showOverflowMenu && (
            <ControlBarEl
              key='entry-actions'
              attrs={{
                elref: `lineActions`,
                theme: ButtonTheme.Tertiary,
                'overflow-controls': overflowControls,
                'overflow-menu-width': 200,
                disabled: el.attr(`disabled`),
              }}
              on={{
                select: (ev: CustomEvent) => el.helpers.onControlSelect(ev.detail.value, index),
              }}
              props={{
                contextPanelTransform: el.helpers.overflowControlsContextPanelTransform,
              }}
            />
          )}
          {/** custom bucketing dropdown */}
          {activeEntry === index && entryPart === EntryPart.CustomBucketing && (
            <div sel='.mp-query-customize-buckets'>
              <DropMenuEl
                attrs={{open: true}}
                on={{
                  change: el.helpers.onCustomizeBucketsMenuChange,
                  click: (ev) => ev.stopPropagation(),
                }}
              >
                <BucketPaneEl
                  attrs={el.helpers.getCustomBucketPaneAttributes()}
                  on={{
                    changeSelectedBucket: el.helpers.onChangeSelectedCustomBucket,
                    resetBucket: el.helpers.onResetCustomBucket,
                  }}
                />
              </DropMenuEl>
            </div>
          )}
        </div>
      )}

      {/** row delete button */}
      {el.helpers.canDeleteEntry() && !isBehavior && !hasNewUI && (
        <ButtonEl
          key='entry-delete-action'
          attrs={{
            elref: `deleteLineButton`,
            theme: ButtonTheme.Tertiary,
            icon: `trashcan`,
            role: `button`,
            disabled: el.attr(`disabled`),
          }}
          on={{
            click: () => el.helpers.onEventActionClick(Action.Remove, index),
          }}
        />
      )}
    </div>
  );
}
